import { z } from 'zod';

// 브라우저 환경에서 File 또는 Blob 타입 검증
const createFileSchema = () => {
  if (typeof File !== 'undefined' && typeof Blob !== 'undefined') {
    return z
      .union([z.instanceof(File), z.instanceof(Blob)])
      .refine((value): value is File | Blob => value instanceof File || value instanceof Blob, {
        message: '유효한 파일 형식이 아닙니다.',
      });
  }
  return z.any(); // 서버 사이드에서는 any로 처리
};

export const CreateAccountInfoServiceRequestSchema = z
  .object({
    businessType: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY']),
    idNumberFirst: z.string().optional(),
    idNumberSecond: z.string().optional(),
    identityFile: createFileSchema().optional(),
    businessName: z.string().optional(),
    businessRegistrationNumber: z.string().optional(),
    businessLicenseFile: createFileSchema().optional(),
    bankName: z
      .string()
      .min(1, '은행을 선택해주세요.')
      .optional()
      .refine((value) => value == null || value.trim().length > 0, {
        message: '은행을 선택해주세요.',
      }),
    accountNumber: z.string().min(1, '계좌번호를 입력하세요.').optional(),
    accountHolder: z.string().min(1, '예금주를 입력하세요.').optional(),
    accountCopyFile: createFileSchema().nullable().optional(),
    termsAgreed: z.boolean().refine((val) => val === true, '정산 정보 수집 이용 동의를 해주세요.'),
  })
  .describe('CreateAccountInfoServiceRequestSchema');

export type CreateAccountInfoServiceRequest = z.infer<typeof CreateAccountInfoServiceRequestSchema>;

export const CreateAccountInfoServiceResponseSchema = z
  .object({
    businessCategory: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY']),
    bankName: z.string(),
    bankAccountNumber: z.string(),
    bankOwnerName: z.string(),
    residentRegistrationNumber: z.string().optional().nullable(),
    registeredBusinessName: z.string().optional().nullable(),
    companyRegistrationNumber: z.string().optional().nullable(),
  })
  .describe('CreateAccountInfoServiceResponseSchema');

export type CreateAccountInfoServiceResponse = z.infer<
  typeof CreateAccountInfoServiceResponseSchema
>;
